<h1 mat-dialog-title>Remove account</h1>
<div mat-dialog-content>
  Are you sure you want to remove the following account ?
  <br/><br/>
  <strong>{{data.email}}</strong>
</div>
<div mat-dialog-actions >
  <button (click)="onConfirm(data.id)" mat-button cdkFocusInitial>Ok</button>
  <button mat-button mat-dialog-close>Cancel</button>
</div>

